<div *ngIf="room" class="container">
    <p-tabView>
        <p-tabPanel header="Setup">
            <div class="row mt-3 mb-3">
                <div class="p-fluid p-field col-10 p-md-12">
                    <span class="p-float-label">
                        <input (ngModelChange)="onTitleChange()" [(ngModel)]="room.title" id="title1" pInputText
                               type="text">
                        <label for="title1">Title</label>
                    </span>
                </div>
                <div class="p-fluid p-field col-2 p-md-12">
                    <p-button (click)="save()" [icon]="saved?'pi pi-check':''" iconPos="right" label="Save"></p-button>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <p-card header="Product">
                        <app-live-products (productsAdded)="onProductAdded($event)"
                                           (productsRemoved)="onProductRemoved($event)" [(products)]="room.products"
                                           [addButton]="true" [deleteColumn]="true"
                                           [priceColumn]="true" [room]="room"></app-live-products>
                    </p-card>
                </div>
            </div>
            <div class="row" style="margin-top: 10px">
                <div class="col-12">
                    <p-card header="Thumbnail">
                        <div class="row">
                            <div class="col-10">
                                <input (ngModelChange)="onTitleChange()" [(ngModel)]="room.thumbnailUrl"
                                       pInputText style="width: 100%;margin-bottom: 10px" type="text">
                            </div>
                            <div class="col-2">
                                <img [src]="room.thumbnailUrl ? room.thumbnailUrl : 'assets/img/notfound.jpeg'" alt=""
                                     class="img-product-highlight"
                                     style="width: 100px;height: 100px"/>
                            </div>
                        </div>
                    </p-card>
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Live">
            <div class="row mt-3 mb-3">
                <div class="p-fluid p-field col-10 p-md-12">
                    <span class="p-float-label">
                        <input (ngModelChange)="onTitleChange()" [(ngModel)]="room.title" id="title2" pInputText
                               type="text">
                        <label for="title2">Title</label>
                    </span>
                </div>
                <div class="p-fluid p-field col-2 p-md-12">
                    <p-button (click)="save()" [icon]="saved?'pi pi-check':''" iconPos="right" label="Save"></p-button>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <p-card header="Product">
                        <app-live-products (selectedProduct)="onProductSelected($event)" [addRadio]="true"
                                           [products]="room.products"
                                           [selectedIProduct]="selectedProduct"></app-live-products>
                        <div class="row justify-content-center" style="margin-top: 20px">
                            <p-button (click)="promoteOrDemoteProduct(true)" [disabled]="!selectedProduct"
                                      icon="pi pi-volume-up"
                                      iconPos="right"
                                      label="Promote"></p-button>
                        </div>
                        <div *ngIf="promotedProduct" class="room-product-highlight" style="margin-top: 20px">
                            <img [src]="promotedProduct.imageUrl" alt="" class="img-product-highlight"/>
                            <span class="price-product-highlight">{{promotedProduct.sellingPrice ? promotedProduct.sellingPrice : promotedProduct.basePrice}}</span>
                            <button (click)="promoteOrDemoteProduct(false)" class="btn btn-danger btn-circle"
                                    type="button"><i class="pi pi-times"></i></button>
                        </div>
                    </p-card>
                </div>
                <div *ngIf="!liveMode" class="col-8">
                    <div class="row">
                        <div class="col-4 text-right">
                            Choose Method:
                        </div>
                        <div class="col-4 text-center">
                            <p-button [style]="{width: '100%'}" label="Streaming Key"></p-button>
                        </div>
                        <div class="col-4 text-center">
                            <p-button [style]="{width: '100%'}" disabled="true" label="Camera"></p-button>
                        </div>
                    </div>
                    <div class="row" style="margin: 10px">
                        <div class="col-6 text-right form-group">
                            Streaming URL:
                        </div>
                        <div class="col-6 form-group">
                            <div class="p-inputgroup">
                                <input [value]="room.streamUrl" disabled="true" pInputText type="text">
                                <button (click)="copyStreamUrl(room.streamUrl)" icon="pi pi-copy" pButton pRipple
                                        styleClass="p-button-warn"
                                        type="button"></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="liveMode" class="col-8">
                    <d-player [style]="{width: '100%', height: '350px'}" [video]="{url: room.hlsUrl}" autoplay="true"
                              dpHls
                              live="true"></d-player>
                    <div class="view-amount">
                        <mat-icon class="view-num-icon-mobile">visibility</mat-icon>
                        <span class="view-text">{{viewAmount || 0}} </span>
                    </div>
                    <app-live-message (viewAmountToViewer)="getViewAmount($event)" *ngIf="liveMode"
                                      [channelId]="room.chatId" [displayName]="room.shopName ? room.shopName : ''"
                                      [isSeller]="true" [userId]="room.user"></app-live-message>
                </div>
                <div class="col-4"></div>
                <div class="col-8">
                    <div class="row justify-content-center" style="margin: 20px">
                        <button (click)="updateStatus()" class="btn btn-danger"
                                type="button">{{liveMode ? 'END' : 'LIVE'}}</button>
                    </div>
                </div>
            </div>
        </p-tabPanel>
    </p-tabView>
</div>
